<template>
  <div class="bank" v-loading="loading">
    <div class="bank-first">
      <div class="bank-first-top">
        <div
          class="top-list"
          v-for="(item, index) in bankTitleList"
          :key="index"
          :class="{ active: bankTitleIndex == index }"
          @click="titleBtn(index)"
        >
          <div class="top-list-title">{{ item }}</div>
          <div class="top-list-lint" v-if="bankTitleIndex == index"></div>
        </div>
      </div>

      <div class="bank-first-center">
        <div class="first-center-list" v-for="(item, index) in 3" :key="index">
          <div class="first-center-list-title">
            {{
              index == 0
                ? '持卡人姓名'
                : index == 1
                ? '用户id'
                : '银行卡预留手机号'
            }}
          </div>

          <div class="first-center-list-input">
            <el-input
              v-if="index == 0"
              placeholder="持卡人姓名"
              v-model="bankName"
              clearable
            ></el-input>
            <el-input
              v-if="index == 1"
              placeholder="用户id"
              v-model="bankUserid"
              clearable
            ></el-input>
            <el-input
              v-if="index == 2"
              placeholder="银行卡预留手机号"
              v-model="bankPhone"
              clearable
            ></el-input>
          </div>
        </div>
      </div>

      <div class="bank-first-bottom">
        <div class="first-bottom-inquire" @click="bankInquire">查询</div>
        <div class="first-bottom-reset" @click="bankReset">重置</div>
      </div>
    </div>

    <div class="bank-second">
      <div class="bank-second-div">
        <div class="bank-second-div-left">查询结果</div>
        <div class="bank-second-div-right">
          <div class="bank-second-div-right-refresh" @click="refreshClick">
            刷新
          </div>
        </div>
      </div>

      <div class="bank-second-table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          border=""
          @selection-change="handleSelectionChange"
          :header-cell-style="{
            color: '#333333',
            backgroundColor: '#FAFAFA',
          }"
        >
          <!-- 自定义暂无数据 -->
          <template slot="empty">
            <div class="empty-block">
              <img
                class="empty-block-img"
                src="../../assets/common/common-empty.png"
              />
              <div class="empty-block-text">暂无数据～</div>
            </div>
          </template>
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column
            prop="id"
            label="申请编号"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="nickname"
            label="申请用户"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="userhome_id"
            label="用户id"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="realname"
            label="持卡人姓名"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="phone"
            label="银行卡预留手机号"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="申请时间"
            width="160"
          ></el-table-column>
          <el-table-column label="银行卡正面" width="113">
            <template slot-scope="scope">
              <div class="table-img" @click="previewMet(scope.row, 0)">
                <el-image
                  ref="preview"
                  style="width: 70px; height: 50px"
                  :src="scope.row.front_img"
                  :preview-src-list="srcList0"
                  :initial-index="srcList0Index"
                ></el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="银行卡反面" width="113">
            <template slot-scope="scope">
              <div class="table-img" @click="previewMet(scope.row, 1)">
                <el-image
                  ref="preview1"
                  style="width: 70px; height: 50px"
                  :src="scope.row.back_img"
                  :preview-src-list="srcList1"
                  :initial-index="srcList1Index"
                ></el-image>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="createTime"
            label="创建时间"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="uptatetime"
            label="处理时间"
            width="150"
          ></el-table-column>
          <el-table-column label="审核状态" width="150">
            <template slot-scope="scope">
              <div
                :style="{
                  color: scope.row.status == 1 ? '#36C100' : '#FF3333',
                }"
              >
                {{
                  scope.row.status == 0
                    ? '待审核'
                    : scope.row.status == 1
                    ? '审核通过'
                    : scope.row.status == 2
                    ? '申请驳回'
                    : ''
                }}
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="" label="操作" width="106" fixed="right">
            <template slot-scope="scope">
              <div class="table-operation" v-if="scope.row.status == 0">
                <div
                  class="table-operation-title"
                  @click="auditClick(scope.row)"
                >
                  审核
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="integral-second-Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="prev, pager, next, sizes"
          :total="totalNum"
        >
        </el-pagination>
      </div>
    </div>

    <div class="information">
      <el-dialog
        :visible.sync="informationDialogVisible"
        @close="informationCancel"
      >
        <span slot="footer" class="dialog-footer">
          <div class="information-title">
            <div class="title">银行卡信息详情</div>
            <img
              @click="informationCancel"
              class="img"
              src="../../assets/common/close.png"
              alt=""
            />
          </div>

          <div class="information-div">
            <div class="div">
              <div class="div-list" v-for="(item, index) in 5" :key="index">
                <div class="list-title">
                  {{
                    index == 0
                      ? '申请用户'
                      : index == 1
                      ? '用户id'
                      : index == 2
                      ? '申请时间'
                      : index == 3
                      ? '申请编号'
                      : index == 4
                      ? '审核状态'
                      : ''
                  }}
                </div>

                <div class="list-value">
                  {{
                    index == 0
                      ? informationObj.nickname
                      : index == 1
                      ? informationObj.userhome_id
                      : index == 2
                      ? informationObj.createTime
                      : index == 3
                      ? informationObj.id
                      : index == 4
                      ? informationObj.status == 0
                        ? '待审核'
                        : informationObj.status == 1
                        ? '审核通过'
                        : informationObj.status == 2
                        ? '申请驳回'
                        : ''
                      : ''
                  }}
                </div>
              </div>
            </div>
            <div class="div" style="border-bottom: 0">
              <div class="div-list" v-for="(item, index) in 5" :key="index">
                <div class="list-title">
                  {{
                    index == 0
                      ? '持卡人'
                      : index == 1
                      ? '银行卡绑定手机号'
                      : index == 2
                      ? '银行卡账号'
                      : index == 3
                      ? '银行名称'
                      : '银行支行名称'
                  }}
                </div>

                <div class="list-value">
                  {{
                    index == 0
                      ? informationObj.realname
                      : index == 1
                      ? informationObj.phone
                      : index == 2
                      ? informationObj.bank_number
                      : index == 3
                      ? informationObj.bank_name
                      : informationObj.bank_branch_name
                  }}
                </div>
              </div>
            </div>
          </div>

          <div class="information-block">
            <div class="block-title">审核消息发送</div>
            <div class="block-select">
              <div class="select-title">修改审核状态</div>
              <div class="select">
                <el-select v-model="bankValue" clearable placeholder="请选择">
                  <el-option
                    v-for="item in informationOption"
                    :key="item.index"
                    :label="item.title"
                    :value="item.index"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="block-text">审核理由</div>
            <div class="block-textarea">
              <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="informationTextarea"
                maxlength="200"
                show-word-limit
              >
              </el-input>

              <div class="textarea-display">
                <el-upload
                  class="display-upload"
                  action="https://laravel-api-manager.xmw1688.com/common/upload"
                  list-type="picture-card"
                  :on-success="handleSuccessList"
                  :limit="3"
                  :show-file-list="false"
                  ref="upload"
                >
                  <div
                    class="display-upload-list"
                    v-for="(item, index) in bankList"
                    :key="index"
                  >
                    <img class="display-upload-list-img" :src="item" alt="" />
                    <img
                      class="display-upload-detele"
                      src="../../assets/common/common-detele.png"
                      alt=""
                      @click.stop="informationList(index)"
                    />
                  </div>
                  <img
                    class="display-upload-list"
                    style="cursor: pointer"
                    src="../../assets/common/common-uploadings.png"
                    v-if="bankList.length < 3"
                  />
                </el-upload>
              </div>
            </div>
          </div>
          <div class="information-button">
            <!-- <div class="button-reset" @click="abilityReset">重 置</div> -->
            <div class="button-confirm" @click="informationConfirm">确 定</div>
          </div>
        </span>
      </el-dialog>
    </div>

    <!--第二区域  进行禁用-->
    <div class="audit">
      <el-dialog
        :visible.sync="auditDialogVisible"
        style="margin-top: 10vh"
        @close="auditCancel"
      >
        <span slot="footer" class="dialog-footer">
          <div class="audit-password">
            <div class="password">
              <img
                class="password-img"
                src="../../assets/common/common-warning.png"
              />
            </div>

            <div class="title">是否确定修改审核状态？</div>
            <div class="text">一旦确定后则不能更改，并且用户会收到审核信息</div>
          </div>

          <div class="audit-button">
            <div class="button-left" @click="auditConfirm">确定</div>
            <div class="button-right" @click="auditCancel">取消</div>
          </div>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getBankInfo, postUpdateBank } from '../../api/partenr'

export default {
  data() {
    return {
      // 第一区域 表头数组
      bankTitleList: ['待审核', '已通过', '已驳回'],
      // 第一区域 表头数组下标选中
      bankTitleIndex: 0,
      // 第一区域 用户id
      bankUserid: '',
      bankPhone: '',
      bankName: '',
      bankStatus: 0,
      // 第二区域 表格数组
      tableData: [],
      // 第二区域 表格总条数
      totalNum: 0,
      // 存储表格选中的值
      multipleSelection: [],
      // 页码
      page: 1,
      // 页数
      limit: 10,
      // 监听用户刷新
      loading: false,
      // 控制当前页面功能性按钮开关
      bankFunShow: false,

      // 弹出框
      informationDialogVisible: false,
      informationObj: {},
      bankValue: '',
      informationOption: [
        {
          index: 0,
          title: '待审核',
        },
        {
          index: 1,
          title: '已通过',
        },
        {
          index: 2,
          title: '已驳回',
        },
      ],
      informationTextarea: '',
      //----------上传
      bankList: [],
      //-----------弹出框
      auditDialogVisible: false,
      srcList0: [],
      srcList0Index: '',
      srcList1Index: 0,
      srcList1: [],
      //---------
      previewDialogVisible: false,
    }
  },
  created() {
    this.loading = true
    // 获取销售订单基本数据
    this.getBankInfoClick()

    setTimeout(() => {
      this.bankFunShow = this.$store.state.pageFunctionShow
    }, 1000)
  },
  methods: {
    getBankInfoClick() {
      let params = {
        userId: this.bankUserid,
        phone: this.bankPhone,
        name: this.bankName,
        status: this.bankStatus,
        createStartTime: '',
        createEndTime: '',
        type: 0,
        pageNo: this.page,
        pageSize: this.limit,
      }

      getBankInfo(params).then((res) => {
        if (res.resultStatus == true) {
          // 获取表格数组
          this.tableData = res.resultData.list
          this.tableData.forEach((item, index) => {
            this.srcList0.push(item.front_img)
            this.srcList1.push(item.back_img)
          })

          // 获取总数
          this.totalNum = res.resultData.totalNum
          this.loading = false
        }
      })
    },

    // 点击对应分类进行切换
    titleBtn(index) {
      this.bankTitleIndex = index
      this.bankStatus = index
      this.loading = true
      this.getBankInfoClick()
    },
    bankInquire() {
      this.$nextTick(() => {
        this.getBankInfoClick()
      })
    },
    bankReset() {
      this.bankTitleIndex = 0
      this.bankUserid = ''
      this.bankPhone = ''
      this.bankName = ''
      this.bankStatus = 0
      this.loading = true

      this.$nextTick(() => {
        this.getBankInfoClick()
      })
    },
    // 刷新
    refreshClick() {
      this.loading = true
      //   this.getOrderlistClick()

      this.$nextTick(() => {
        this.getBankInfoClick()
      })
    },
    // 表格区域点击选中 勾选对应的
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 审核  弹出框
    auditClick(item) {
      if (this.bankFunShow == false) {
        this.$message.error('暂无权限！')
        return
      }

    //   this.srcList0 = []
    //   this.srcList1 = []
      this.informationObj = item
      this.bankValue = item.status

      if (item.reason != null) {
        let text = item.reason.split(';')
        let array = []
        let title = ''

        text.forEach((item, index) => {
          if (item.substring(0, 23) == 'https://oss.xmw1688.cn') {
            array.push(item)
          } else {
            title = item
          }
        })

        this.informationTextarea = title
        this.bankList = array
      }

      this.informationDialogVisible = true
    },
    informationCancel() {
      this.informationDialogVisible = false
    },

    // 上传
    handleSuccessList(file, fileList) {
      this.$refs.upload.clearFiles()
      this.bankList.push(file.resultData)
    },
    informationList(index) {
      this.bankList.splice(index, 1)
    },

    // 二次取消  确定
    auditCancel() {
      this.auditDialogVisible = false
    },
    auditConfirm() {
      let img = this.bankList.join(';')
      let str = this.informationTextarea + ';' + img

      if (str == ';') {
        str = ''
      }

      let params = {
        id: this.informationObj.id,
        status: this.bankValue,
        reason: str,
      }

      postUpdateBank(params).then((res) => {
        if (res.resultStatus == true) {
          this.$message({
            message: '审核成功!',
            type: 'success',
          })

          this.informationDialogVisible = false
          this.auditDialogVisible = false
          this.getBankInfoClick()
        }
      })
    },

    informationConfirm() {
      this.auditDialogVisible = true
    },

    previewMet(item, indexs) {

    },

    // 查询当前页码多少条
    handleSizeChange(val) {
      this.limit = val
      this.loading = true
      this.getBankInfoClick()
    },
    // 查询当前页
    handleCurrentChange(val) {
      this.page = val
      this.loading = true
      this.getBankInfoClick()
    },
  },
}
</script>

<style lang="less" scoped>
.bank {
  position: relative;
  width: 100%;

  .bank-first {
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    padding: 0 24px 24px;
    box-sizing: border-box;

    .bank-first-top {
      display: flex;
      height: 55px;
      border-bottom: 1px solid #f4f5f9;

      .top-list {
        width: 66px;
        height: 55px;
        position: relative;
        margin-right: 30px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        .top-list-title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }

        .top-list-lint {
          position: absolute;
          bottom: 0;
          width: 56px;
          height: 4px;
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          border-radius: 15px 15px 0px 0px;
        }
      }

      .active {
        .top-list-title {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #222222;
        }
      }
    }

    .bank-first-center {
      display: flex;
      margin-top: 20px;

      .first-center-list {
        margin-right: 22px;

        .first-center-list-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .first-center-list-input {
          width: 100%;
          margin-top: 4px;

          /deep/ .el-input {
            height: 32px;
            width: 186px;
          }

          /deep/ .el-input__inner {
            padding: 0 10px;
            box-sizing: border-box;
            height: 32px;
            background-color: rgba(255, 255, 255, 0);
          }

          /deep/ .el-select .el-input.is-focus .el-input__inner {
            border-color: rgba(217, 217, 217, 1);
          }

          /deep/ .el-range-editor.el-input__inner {
            padding: 0;
            padding: 0 12px;
            box-sizing: border-box;
          }

          /deep/ .el-date-editor--daterange.el-input__inner {
            width: 382px;
          }

          /deep/ .el-date-editor .el-range-separator {
            width: 26px;
            padding: 0;
            height: 32px;
            line-height: 32px;
            background-image: url('../../assets/activities/activities-right.png');
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }

      .first-center-list:last-child {
        margin-right: 0;
      }
    }

    .bank-first-bottom {
      display: flex;
      margin-top: 27px;

      .first-bottom-inquire,
      .first-bottom-reset {
        width: 110px;
        height: 36px;
        background: #222222;
        border-radius: 10px;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
      }

      .first-bottom-reset {
        background: #f4f5f9;
        margin-left: 10px;
        color: #999999;
      }
    }
  }

  .bank-second {
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    margin-top: 24px;
    padding: 24px;
    box-sizing: border-box;

    .bank-second-div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;

      .bank-second-div-left {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #222222;
      }

      .bank-second-div-right {
        display: flex;
        align-items: center;
        justify-content: center;

        .bank-second-div-right-refresh {
          width: 70px;
          height: 36px;
          border-radius: 10px;
          border: 1px solid rgba(34, 34, 34, 0.4);
          text-align: center;
          line-height: 36px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #222222;
          cursor: pointer;
        }

        .bank-second-div-right-derive {
          width: 110px;
          height: 36px;
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          border-radius: 10px;
          margin-left: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          .bank-second-div-right-derive-img {
            width: 12px;
            height: 12px;
          }

          .bank-second-div-right-derive-text {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            margin-left: 8px;
          }
        }
      }
    }

    .bank-second-table {
      /deep/ .el-table thead {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        background: #d8d8d8;
      }

      /deep/ .el-table td.el-table__cell div {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 400;
      }

      /deep/ .el-table tr {
        height: 46px;
      }

      /deep/ .el-table__empty-text {
        line-height: 0;
      }

      /deep/ .el-table__cell {
        // vertical-align: top;
      }

      .empty-block {
        margin-top: 62px;
        padding-bottom: 40px;

        .empty-block-img {
          width: 130px;
          height: 130px;
          margin: 0 auto;
        }

        .empty-block-text {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          margin-top: 10px;
          height: 17px;
          line-height: 17px;
        }
      }

      .table-img {
        height: 70px;
        // background: #F0F0F0;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }

      .table-ordernum {
        .table-ordernum-title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
        }

        .table-ordernum-img {
          margin-top: 9px;
          width: 15px;
          height: 16px;
          cursor: pointer;
        }
      }

      .table-recipients {
        .table-recipients-phone {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
        }

        .table-recipients-address {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
          line-height: 22px;
          margin-top: 5px;
          word-break: break-all;
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }

      .table-user {
        .table-user-name {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
        }

        .table-user-relation {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2aa4ff;
          text-decoration: underline;
          cursor: pointer;
        }
      }

      .table-status {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }

      .table-commodity {
        display: flex;
        align-content: center;
        margin-bottom: 10px;

        .table-commodity-left {
          width: 70px;
          height: 70px;
          border: 1px solid #ccc;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .table-commodity-right {
          width: 196px;
          margin-left: 12px;

          .table-commodity-right-title {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #555555;
            line-height: 22px;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .table-commodity-right-text {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #555555;
            margin-top: 4px;
          }
        }
      }

      .table-commodity:last-child {
        margin-bottom: 0;
      }

      .table-commodityPrice {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #555555;
        margin-bottom: 4px;
      }

      .table-commodityPrice:last-child {
        margin-bottom: 0;
      }

      .table-paytype {
        .table-paytype-title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
        }

        .table-paytype-img {
          width: 34px;
          height: 34px;
          margin-top: 7px;
        }
      }

      .table-operation {
        display: flex;
        align-items: center;

        .table-operation-title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2aa4ff;
          text-decoration: underline;
          cursor: pointer;
        }
      }

      .table-logistics {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2aa4ff;
        text-decoration: underline;
        cursor: pointer;
      }
    }

    .integral-second-Pagination {
      height: 88px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      /deep/ .el-pagination .btn-prev {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        margin-right: 8px;
      }

      /deep/ .el-pagination .btn-next {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
      }

      /deep/ .el-pager li {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        line-height: 32px;
        margin-right: 8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }

      /deep/ .el-pager li.active {
        background: #000000;
        color: #ffffff;
      }

      /deep/ .el-input--mini .el-input__inner {
        height: 32px;
      }

      /deep/ .el-input__inner {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }

  .information {
    /deep/ .el-dialog {
      width: 845px;
      height: 600px;
      overflow: auto;
    }

    /deep/ .el-dialog__footer {
      padding: 0;
      box-sizing: border-box;
    }

    .information-title {
      height: 56px;
      width: 100%;
      border-bottom: 1px solid #e8e8e8;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 16px;
      box-sizing: border-box;

      .title {
        font-size: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #222222;
      }

      .img {
        width: 11px;
        height: 10px;
        cursor: pointer;
      }
    }

    .information-div {
      .div {
        padding: 20px 24px 6px;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        // justify-content: space-between;

        border-bottom: 1px solid #e8e8e8;

        .div-list,
        .div-list1 {
          width: calc(100% / 3 - 50px);
          text-align: left;
          margin-bottom: 14px;
          margin-right: 75px;

          .list-title {
            font-size: 12px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 17px;
          }

          .list-value {
            font-size: 14px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #222222;
            line-height: 20px;
            margin-top: 4px;
          }

          .list-img {
            display: flex;
            margin-top: 4px;

            .img1 {
              width: 150px;
              height: 149px;
              background: #f0f0f0;
              display: flex;
              justify-content: center;
              align-items: center;

              img {
                width: 150px;
                height: 115px;
                object-fit: cover;
              }
            }
          }
        }

        .div-list:nth-child(3n + 3) {
          margin-right: 0;
        }

        .div-list1 {
          width: 100%;
        }
      }
    }

    .information-block {
      padding: 21px 23px;
      box-sizing: border-box;
      text-align: left;

      .block-title {
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #222222;
      }

      .block-select {
        margin-top: 12px;

        .select-title {
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #999999;
        }

        .select {
          margin-top: 5px;
        }
      }

      .block-text {
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin-top: 14px;
      }

      .block-textarea {
        height: 206px;
        background: #ffffff;
        border-radius: 5px;
        border: 1px solid #d9d9d9;
        margin-top: 5px;
        padding: 0 12px;
        box-sizing: border-box;

        /deep/ .el-textarea__inner:hover {
          border: 0;
        }

        /deep/ .el-textarea__inner {
          border: 0;
          resize: none;
          height: 100px;
        }

        .textarea-display {
          .display-upload {
            display: flex;

            /deep/ .el-upload--picture-card {
              width: 100%;
              height: 100px;
              display: flex;
              align-items: center;
              border: 1px solid rgba(255, 255, 255, 0);
            }

            /deep/ .el-upload--picture-card:hover {
              border-color: rgba(255, 255, 255, 0);
            }

            /deep/ .el-upload-list--picture-card .el-upload-list__item {
              width: 84px;
              height: 84px;
              margin: 0;
            }

            .display-upload-list {
              width: 84px;
              height: 84px;
              margin-right: 24px;
              position: relative;
              border: 1px solid rgba(255, 255, 255, 0);

              .display-upload-list-img {
                width: 84px;
                height: 84px;
              }
            }

            .display-upload-list:last-child {
              margin-right: 0;
            }

            .display-upload-detele {
              position: absolute;
              top: -10px;
              right: -10px;
              width: 20px;
              height: 20px;
            }
          }
        }
      }
    }

    .information-button {
      width: 100%;
      height: 52px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0 16px;
      box-sizing: border-box;
      border-top: 1px solid #d9d9d9;
      margin-top: 25px;

      .button-reset,
      .button-confirm {
        width: 65px;
        height: 32px;
        background: #ffffff;
        border-radius: 10px;
        border: 1px solid #e9edf4;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #555555;
        text-align: center;
        line-height: 32px;
        cursor: pointer;
      }

      .button-confirm {
        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
        color: #ffffff;
        margin-left: 8px;
      }
    }
  }

  .audit {
    /deep/ .el-dialog {
      height: 231px;
      width: 394px;
    }

    /deep/ .el-dialog__footer {
      padding: 25px 0;
      box-sizing: border-box;
    }

    .audit-password {
      width: 100%;

      .password {
        display: flex;

        .password-img {
          width: 56px;
          height: 56px;
          margin: 0 auto;
        }
      }

      .title {
        font-size: 18px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        margin: 15px 0 5px;
        text-align: center;
      }

      .text {
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        text-align: center;
      }
    }

    .audit-button {
      display: flex;
      justify-content: center;
      align-content: center;
      margin-top: 30px;

      .button-left,
      .button-right {
        width: 88px;
        height: 32px;
        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
        border-radius: 10px;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
      }

      .button-right {
        margin-left: 8px;
        border: 1px solid #e9edf4;
        color: rgba(0, 0, 0, 0.65);
        background: #ffffff;
      }
    }
  }
}
</style>
